import React from 'react';
import {Button} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ForgotPassword({
  open,
  setOpen,
}) {

  const handleOk = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: { paddingBottom: '8px' } 
      }}
    >
        <DialogTitle
          id="alert-dialog-slide-title"
          style={{ textAlign: 'center' }}
        >
          <span style={{ fontSize: '20px', color: '#1E2323', fontWeight: '600' }}>
            {'Quên mật khẩu'}
          </span>
        </DialogTitle>
        <DialogContent >
          <DialogContentText 
            id="alert-dialog-slide-description"
            style={{
              textAlign: 'center', 
              display: 'flex', 
              justifyContent: 'center',  
              alignItems: 'center',     
              maxWidth: '320px', 
              margin: '0 auto'    
            }}
          >
            <span style={{
              display: 'block',     
              whiteSpace: 'normal',  
              wordBreak: 'break-word', 
              maxWidth: '80%',      
              margin: '0 auto',   
            }}>
             {'Vui lòng liên hệ với quản trị viên để được cấp lại mật khẩu.'}
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{display:'flex', justifyContent:'center'}}>
          <Button
            style={{ marginRight: '10px', textTranform: 'none !important' }}
            className="btn-main mx-2"
            variant="contained"
            onClick={handleOk}
            color="primary"
          >
            {'Đã hiểu'}
          </Button>
        </DialogActions>
    </Dialog>
  );
}
